import {
  alpha,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Icon,
  styled,
  Typography,
} from '@mui/material';
import { StyledMUIButton } from 'src/components/Button';
import { LoadingSpinner } from 'src/components/Loading';

export const Flex = styled('div')`
  display: flex;
`;

export const FlexRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FlexColumn = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const LeftColumn = styled(FlexColumn)`
  display: flex;
  flex-direction: column;
  width: 50%;
`;
export const RightColumn = styled(FlexColumn)`
  display: flex;
  flex-direction: column;
  width: 50%;
`;

export const Label = styled(Typography)`
  font-weight: bold;
`;

export const Spinner = styled(LoadingSpinner)`
  min-width: 5rem;
  width: 5rem;
  height: 5rem;
`;

export const FileDetailsDialogTitle = styled(DialogTitle)`
  padding: 1.3rem 2rem;
  background-color: ${({ theme }) => theme.palette.grey[900]};
  color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 4px 4px 0px 0px;
  margin-bottom: 1rem;
`;

export const FileDetailsDialogContent = styled(DialogContent)`
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  height: fit-content;
`;

export const FilesListContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 0 2.5rem;
  gap: 1rem;
`;

export const StyledDivider = styled(Divider)`
  border-color: ${({ theme }) => theme.palette.grey[900]};
  position: absolute;
  bottom: 0;
  left: -5rem;
  right: -5rem;
`;

export const HeadersContainer = styled('div')`
  position: relative;
  padding: 1rem 0;
`;

export const CancelButton = styled(StyledMUIButton)`
  background-color: ${({ theme }) => theme.palette.grey[900]};
  box-shadow: none;
  color: ${({ theme }) => theme.palette.grey[100]};
  &:hover {
    box-shadow: none;
    background-color: ${({ theme }) => alpha(theme.palette.secondary.main, 0.08)};
  }
`;
CancelButton.defaultProps = { size: 'large' };

export const StyledDialogActions = styled(DialogActions)`
  padding: 1rem 2rem;
  gap: 2rem;
  background-color: ${({ theme }) => theme.palette.grey[900]};
  border-radius: 0px 0px 4px 4px;
`;

export const OutlinedButton = styled(Button)`
  text-transform: none;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.grey[900]};
  background-color: ${({ theme }) => theme.palette.common.white};

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[300]};
  }
`;

OutlinedButton.defaultProps = { variant: 'outlined' };

export const TextFieldContainer = styled(FlexColumn)`
  width: 100%;
`;

export const RemoveFileIcon = styled(Icon)`
  position: absolute;
  top: 0;
  left: -3rem;
  height: auto;
  width: auto;
  color: ${({ theme }) => theme.palette.grey[900]};
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.palette.secondary.main};
  }
`;

export const FileNameContainer = styled(FlexRow)`
  position: relative;
  align-items: left;
`;

export const FileDetailsRowContainer = styled(FlexColumn)`
  margin: 1rem 0;
  position: relative;
  gap: 1rem;
`;

export const RowDivider = styled(Divider)`
  margin: 1rem 0;
  position: absolute;
  bottom: -2rem;
  left: -5rem;
  right: -5rem;
`;
